export const PARTICIPANTS_COUNT_ERROR = 'PARTICIPANTS_COUNT_ERROR';

const MAX_ACTIVE_LINKS_ERROR = 'MAX_ACTIVE_LINKS_ERROR';

export class MaxActiveLinksError extends Error {
  readonly maxActiveLinks: number;

  readonly currentActiveLinks: number;

  constructor(maxActiveLinks: number, currentActiveLinks: number) {
    super(MAX_ACTIVE_LINKS_ERROR);
    this.name = MAX_ACTIVE_LINKS_ERROR;
    this.maxActiveLinks = maxActiveLinks;
    this.currentActiveLinks = currentActiveLinks;
  }
}
